export const paletteThemes = [
    {
      label: 'Default',
      colors: ['#ffbe0b', '#fb5607', '#ff006e', '#8338ec', '#3a86ff'],
    },
  
    {
      label: 'Colorful and Balanced',
      colors: ['#E27D60', '#85DCB', '#E8A87C', '#C38D9E', '#41B3A3'],
    },
  
    {
      label: 'Bright Accent Colors',
      colors: ['#242582', '#553D67', '#F64C72', '#99738E', '#2F2FA2'],
    },
  
    {
      label: 'Natural and Earthy',
      colors: ['#8D8741', '#659DBD', '#DAAD86', '#BC986A', '#FBEEC1'],
    },
  
    {
      label: 'Cheerful and Energetic',
      colors: ['#FBE8A6', '#F4976C', '#303C6C', '#B4DFE5', '#D2FDFF'],
    },
  
    {
      label: 'Artsy and Creative',
      colors: ['#D79922', '#EFE2BA', '#F13C20', '#4056A1', '#C5CBE3'],
    },
  
    {
      label: 'Clean and Energetic',
      colors: ['#5680E9', '#84CEEB', '#5AB9EA', '#C1C8E4', '#8860D0'],
    },
  
    {
      label: 'Vibrant and Elegant',
      colors: ['#F8E9A1', '#F76C6C', '#A8D0E6', '#374785', '#24305E'],
    },
  
    {
      label: 'Bright Pink and Pastels',
      colors: ['#A1C3D1', '#B39BC8', '#F0EBF4', '#F172A1', '#E64398'],
    },
    
    {
      label: 'Rich and Colorful',
      colors: ['#F78888', '#F3D250', '#ECECEC', '#90CCF4', '#5DA2D5'],
    },
  ];